import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/docs/templates')({
  loader: () => {
    const enPage = getStaticPage('templates', 'en')
    const dePage = getStaticPage('templates', 'de')
    
    if (!enPage && !dePage) {
      throw notFound()
    }
    
    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'Templates - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Structure, Placeholders & Management' }
    ],
  }),
  component: TemplatesDocs,
})

function TemplatesDocs() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()
  
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage
  
  if (!page) {
    return <NotFound />
  }

  return (
    <Markdown 
      content={page.content} 
      className="prose prose-gray dark:prose-invert max-w-none"
    />
  )
}
